import { groupSeriesByMinute } from './shared';

function getTypes(seriesData) {
  return [...new Set(seriesData.map((serie) => serie.type))];
}

export default {
  buildFields(seriesData) {
    const types = getTypes(seriesData);
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      ...types.map((type) => ({
        key: `${type.toLowerCase()}Rpm`,
        label: `${type.charAt(0)}${type.slice(1).toLowerCase()} RPM`,
        class: 'text-center',
      })),
    ];
  },
  buildLogs(seriesData) {
    const types = getTypes(seriesData);
    const keys = types.map((type) => `${type.toLowerCase()}Rpm`);
    return groupSeriesByMinute(seriesData, keys, (row, serie) => {
      row[`${serie.type.toLowerCase()}Rpm`] = serie.rpm;
    });
  },
  buildSummary() {
    return {};
  },
};
